






























import { Component, Inject } from 'vue-property-decorator';
import Vue from 'vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';

@Component<SideBar>({
  components: { CSideBar },
})
export default class SideBar extends Vue {
  @Inject('sideDrawer')
  sideDrawer!: boolean;
}
